import moment from "moment";

/**
 * Basic Station model.
 *
 */
class StationModel {
  constructor(props) {
    this.id = props.id;
    this.name = props.name;
    this.latitude = props.latitude;
    this.longitude = props.longitude;
    this.enabled = props.enabled;
    this.active = props.active;
    this.period = props.period;
    this.year = props.year;
    this.serialNumber = props.serialNumber;
    this.latestMeasurement = props.latestMeasurement;
    this.showAllMeasurements = props.showAllMeasurements;
    this.showFiveMinutesMeasurements = props.showFiveMinutesMeasurements;
    this.startDate = null;
    if (props.activePeriodStart) {
      this.startDate = moment(props.activePeriodStart, "X");
    }

    this.endDate = null;
    if (props.activePeriodEnd) {
      this.endDate = moment(props.activePeriodEnd, "X");
    }

    this.measurements = {};
    this.day_measurements = props.day_measurements;
    this.chill = false;
    this.meta = props.meta;
  }
}

export default StationModel;
